"use client";

import { CopyButton } from "@frontend/components/copy-button";

/**
 * A payment identifier the other side has to reproduce exactly. Typing a UPI ID
 * or an IFSC by hand is how money ends up in a stranger's account, so the value
 * is always copyable rather than merely readable.
 */
export function CopyValue({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <dt className="shrink-0 text-ink-muted">{label}</dt>
      <dd className="flex min-w-0 items-center gap-1">
        <span className="min-w-0 truncate font-medium text-ink" title={value}>
          {value}
        </span>
        <CopyButton value={value} label={`Copy ${label}`} />
      </dd>
    </div>
  );
}
